import { Global } from "./base/Global";
import { Header } from "./base/Header";
import Vue from 'Vue';
import store from "./Store/store";
import './Components/IECheck/index';
import './Components/Ecom/index';
import './Components/Porter/index';
import './Components/PorterItem/index';
import './Components/UserManagement/index';
import './Components/Formula';
import './Components/Impersonation/index';
import "core-js/stable";
import "regenerator-runtime/runtime";
import "./Store/store";
import "./Store";
import "./Store/downloadContentStore/dcstore";
import "./Store/productVariantStore/productVariantStore";
import "./Store/barcode/barcodestore";
export * from './Components/Base/DownloadInformationModal';
//export * from "./Components/Base/PorterFunctionTranslatedComponent";
//export * from "./Components/Base/UserInformationComponent";
export * from "./Components/CustomerCenter/index";
export * from './base/VueProvider';



$(document as any).ready(() => {
    const global = new Global();
    const header = new Header();
    global.init(); 
    header.init();
});
